import React, { useState } from 'react';
import ApartmentService from '../../../services/ApartmentService';

function UpdateApartmentComponent(props) {
    const [apartment, setApartment] = useState(props.apartment);

    const updateApartment = (e) => {
        e.preventDefault();
        props.redigerClick();

        ApartmentService
            .updateApartment(apartment)
            .catch(function (err) {
                alert("Der opstod en fejl");
                console.log("Error saving", err);
            });

        return;
    };

    return <div className="row">
        <div className="col-md-12">
            <div className="panel panel-default">
                <div className="panel-body textAlignLeft">
                    <form className="apartmentForm" id="apartmentForm" onSubmit={updateApartment}>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Andels nr.</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.number || ''} onChange={(event) => setApartment({ ...apartment, number: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Adresse</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.address || ''} onChange={(event) => setApartment({ ...apartment, address: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Postnummer</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.postcode || ''} onChange={(event) => setApartment({ ...apartment, postcode: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>By</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.suburb || ''} onChange={(event) => setApartment({ ...apartment, suburb: event.target.value })} type="text" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <label>Type</label>
                                        <input className="form-control" name="type" value={apartment.type || ''} onChange={(event) => setApartment({ ...apartment, type: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>m<sup>2</sup></label><br />
                                        </div>
                                        <input className="form-control" name="type" value={apartment.sqm || ''} onChange={(event) => setApartment({ ...apartment, sqm: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Have?</label><br />
                                        </div>
                                        <input type="checkbox" checked={apartment.garden || false} onChange={(event) => setApartment({ ...apartment, garden: event.target.checked })} />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Altan?</label><br />
                                        </div>
                                        <input type="checkbox" checked={apartment.balcony || false} onChange={(event) => setApartment({ ...apartment, balcony: event.target.checked })} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Kælderrum</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.basement || ''} onChange={(event) => setApartment({ ...apartment, basement: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Loftrum</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.attic || ''} onChange={(event) => setApartment({ ...apartment, attic: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Boligafgift</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.apartmentFee || ''} onChange={(event) => setApartment({ ...apartment, apartmentFee: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Aconto varme</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.acontoheat || ''} onChange={(event) => setApartment({ ...apartment, acontoheat: event.target.value })} type="text" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Varmehaner</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.heathose || ''} onChange={(event) => setApartment({ ...apartment, heathose: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Vinduefang</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.vinduefang || ''} onChange={(event) => setApartment({ ...apartment, vinduefang: event.target.value })} type="text" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Antal andelskroner</label>
                                        </div>
                                        <input className="form-control" name="type" value={apartment.andelskroner || ''} onChange={(event) => setApartment({ ...apartment, andelskroner: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Erhverv?</label><br />
                                        </div>
                                        <input type="checkbox" checked={apartment.company || false} onChange={(event) => setApartment({ ...apartment, company: event.target.checked })} />
                                    </div>
                                    <div className="col-md-6 panelRowPadding ">
                                        <div>
                                            <label>Note</label>
                                        </div>
                                        <textarea className="form-control" rows="2" id="comment" value={apartment.note || ''} onChange={(event) => setApartment({ ...apartment, note: event.target.value })}></textarea>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-offset-6  col-md-3 panelRowPadding">
                                        <button type="button" className="btn btn-primary" onClick={props.redigerClick}>Afbryd</button>
                                    </div>
                                    <div className="col-md-3 panelRowPadding">
                                        <button className="btn btn-primary" type="submit">Gem</button>
                                    </div>

                                </div>
                            </div>
                        </form>
                    </div>
                    <hr></hr>
                </div>
            </div>
        </div>;
}
export default UpdateApartmentComponent;